import React, { useState, useEffect, useCallback } from 'react';
import { View, Text, TextInput, StyleSheet, TouchableOpacity, Clipboard, Image, Platform, ActivityIndicator } from 'react-native';
import { ethers } from 'ethers';
import { magic, network, contractAddress, provider, centralAddress, transferUSDT, createSmartAccountOwner } from '../../../lib/magic';
import { globalConfigurableData, globalConst  } from '../../../utils/globalConstant';
import { globalFontStyle, globalStyle } from '../../../assets';
import QRCode from 'react-native-qrcode-svg';
import { wallet_success, order_yes_contract } from '../../../utils/images';
import Colors from '../../../assets/Color/Colors';
import Header from '../../../commonComponents/Header';
import { Network } from '../../../utils/network';
import debounce from 'lodash.debounce';
import { Button } from '../../../components/core/Button';
import { Input } from '../../../components/core/Input';
import { useForm, FormProvider } from 'react-hook-form';
import { Icon } from '@iconify/react';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import CommonModal from '../../../commonComponents/commonModal';
import CouponSuccessScreen from '../childScreens/couponSuccesScreen';
import { useDispatch } from 'react-redux';
import { showLoader, hideLoader } from '../../../commonComponents/Loader/loader.actions';

const CryptoSelection = ({ onOptionSelect }) => {
    return (
        <View style={styles.container}>
            <View style={styles.optionsContainer}>
                <TouchableOpacity 
                    style={styles.optionItem}
                    onPress={() => onOptionSelect('deposit')}
                >
                    <View style={styles.optionContent}>
                        <View style={styles.iconContainer}>
                            <Icon 
                                icon="solar:planet-linear" 
                                width={32} 
                                height={32}
                                color={globalConfigurableData.primaryTextColor1}
                            />
                        </View>
                        <View style={styles.textContainer}>
                            <Text style={styles.optionTitle}>Deposit Crypto</Text>
                            <Text style={styles.optionDescription}>
                                Transfer crypto from external wallet to TradeX
                            </Text>
                        </View>
                        <View style={styles.arrowContainer}>
                            <Icon 
                                icon="solar:alt-arrow-right-linear" 
                                width={24} 
                                height={24}
                                color={globalConfigurableData.secondaryTextColor1}
                            />
                        </View>
                    </View>
                </TouchableOpacity>

                <View style={styles.separator} />

                <TouchableOpacity 
                    style={styles.optionItem}
                    onPress={() => onOptionSelect('convert')}
                >
                    <View style={styles.optionContent}>
                        <View style={styles.iconContainer}>
                            <Icon 
                                icon="solar:refresh-circle-linear" 
                                width={32} 
                                height={32}
                                color={globalConfigurableData.primaryTextColor1}
                            />
                        </View>
                        <View style={styles.textContainer}>
                            <Text style={styles.optionTitle}>Convert to TradeX</Text>
                            <Text style={styles.optionDescription}>
                                Convert your crypto balance to TradeX credits
                            </Text>
                        </View>
                        <View style={styles.arrowContainer}>
                            <Icon 
                                icon="solar:alt-arrow-right-linear" 
                                width={24} 
                                height={24}
                                color={globalConfigurableData.secondaryTextColor1}
                            />
                        </View>
                    </View>
                </TouchableOpacity>
            </View>
        </View>
    );
};

function WalletRecharge({ moneyOptionArr, navigation }) {
    const dispatch = useDispatch();
    const [balance, setBalance] = useState('');
    const [balanceInWei, setBalanceInWei] = useState('0');
    const [symbol, setSymbol] = useState('');
    const [publicAddress, setPublicAddress] = useState('');
    const [selectedOption, setSelectedOption] = useState(null);
    const [currencyAmount, setCurrencyAmount] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [decimals, setDecimals] = useState(0);
    const [statusMessage, setStatusMessage] = useState('');
    const [couponList, setCouponList] = useState([]);
    const [promoMessage, setPromoMessage] = useState('');
    const [promoSuccessModal, setPromoSuccessModal] = useState(false);
    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const MIN_AMOUNT = 1;

    const methods = useForm({
        defaultValues: {
            walletAddress: '',
            chain: 'Polygon',
            token: 'USDT',
            currentBalance: '',
            exchangeBalance: '',
            amountToConvert: ''
        }
    });

    const {
        formState: { errors },
        control,
        setValue,
        watch,
    } = methods;

    const watchamount = watch('amountToConvert');

    const amountIsValid = React.useMemo(() => {
        if (!watchamount) return false;
        const amount = parseFloat(watchamount);
        if (isNaN(amount)) return false;
        
        try {
            const amountInWei = ethers.parseUnits(watchamount, decimals).toString();
            return amount >= MIN_AMOUNT && BigInt(amountInWei) <= BigInt(balanceInWei);
        } catch (error) {
            return false;
        }
    }, [watchamount, MIN_AMOUNT, decimals, balanceInWei]);

    const {
        control: controlPromo,
        formState: { errors: errors2, isValid: isValid2 },
        handleSubmit: handleSubmitPromo,
        watch: watchPromo,
        setValue: setValuePromo,
    } = useForm({
        mode: 'onChange',
    });

    const watchPromoCode = watchPromo('promoCode');

    useEffect(() => {
        const fetchPublicAddress = async () => {
            try {
                // const info = await magic.wallet.getInfo();
                const smartAccountOwner = await createSmartAccountOwner(network);
                const address = await smartAccountOwner.getAddress();
                setPublicAddress(address);
            } catch (error) {
                console.error("Error fetching public address:", error);
            }
        };

        fetchPublicAddress();
    }, []);

    const fetchBalance = async (publicAddress) => {
        try {
            const provider = new ethers.JsonRpcProvider(network.rpcUrl);
            const abi = [
                "function balanceOf(address owner) view returns (uint256)",
                "function decimals() view returns (uint8)",
                "function symbol() view returns (string)"
            ];
            const contract = new ethers.Contract(contractAddress, abi, provider);

            const [balance,  symbol] = await Promise.all([
                contract.balanceOf(publicAddress),
                // contract.decimals(),
                contract.symbol()
            ]);
            const decimals = 6;

            const formattedBalance = ethers.formatUnits(balance, decimals);

            setBalance(formattedBalance);
            setBalanceInWei(balance.toString());
            setSymbol(symbol);
            setDecimals(decimals);
        } catch (error) {
            console.error("Error fetching balance:", error);
        }
    };

    useEffect(() => {
        if (!publicAddress) return;

        

        fetchBalance(publicAddress);
    }, [publicAddress]);

    useEffect(() => {
        if (balance) {
            methods.setValue('currentBalance', balance);
            methods.setValue('exchangeBalance', `${balance} ${symbol}`);
        }
        if (symbol) {
            methods.setValue('token', symbol || 'USDT');
        }
    }, [balance, symbol]);

    const handleCurrencyChange = (text) => {
        const validInput = text.replace(/[^0-9.]/g, '');
        const decimalCount = (validInput.match(/\./g) || []).length;

        if (decimalCount <= 1) {
            setCurrencyAmount(validInput);
            setValue('amountToConvert', validInput, { 
                shouldValidate: true,
                shouldDirty: true 
            });
        }
    };

    const handleAmountSelect = (amount) => {
        const amountStr = amount.toString();
        setCurrencyAmount(amountStr);
        setValue('amountToConvert', amountStr, { 
            shouldValidate: true,
            shouldDirty: true 
        });
    };

    const copyToClipboard = () => {
        Clipboard.setString(publicAddress);
        alert('Address copied to clipboard!');
    };

    const handleConvert = async () => {
        try {
            if (!amountIsValid) {
                return;
            }

            setIsLoading(true);
            setStatusMessage('Initializing transaction...');

            // await transferUSDT(centralAddress, currencyAmount);
            setStatusMessage('Preparing transaction...');
            const transactionResponse = await transferUSDT(centralAddress, currencyAmount);
            if(transactionResponse?.receipt?.success === false || !transactionResponse?.receipt?.logs?.[0]?.transactionHash) {
                throw new Error(`Transaction failed check hash ${transactionResponse}`);
            }
            setStatusMessage('Awaiting block confirmation...');
            fetchBalance(publicAddress);
            setStatusMessage('Converting tokens to TradeX Credits...');
            let payload = {
                amount: currencyAmount,
                pg: 'magiclink',
                token: 'USDT',
                currency: 'USDT',
                txHash: transactionResponse?.receipt?.logs?.[0]?.transactionHash,
                couponcode: promoMessage,
            };
            
            const res = await Network.createOrderWeb(payload, {
                headers: {
                    appVersion: globalConst.appVersion,
                }
            }, true);

            if (res?.data?.success) {
                setStatusMessage('Recharge successful!');
                setIsLoading(false);
                
                // Navigate to success screen
                if (navigation) {
                    navigation.navigate('WalletStack', {
                        screen: 'WalletStatus',
                        params: {
                            paymentStatus: {
                                status: true,
                                isDeposit: true,
                                title: 'Payment Success!',
                                msg: `Your deposit of ${currencyAmount} USDT has been processed against transaction ID ${transactionResponse.hash}.`,
                                amount: currencyAmount,
                                currency: 'USDT',
                                transactionId: transactionResponse.hash,
                                couponcode: promoMessage
                            }
                        }
                    });
                }
            } else {
                throw new Error(res?.data?.msg || 'Transaction failed');
            }
        } catch (error) {
            console.error("Error during conversion:", error);
            setIsLoading(false);
            setStatusMessage('');
            
            // Navigate to failure screen
            if (navigation) {
                navigation.navigate('WalletStack', {
                    screen: 'WalletStatus',
                    params: {
                        paymentStatus: {
                            status: false,
                            isDeposit: true,
                            title: 'Payment Failed',
                            msg: error.message || 'Transaction failed. Please try again.',
                            amount: currencyAmount,
                            currency: 'USDT'
                        }
                    }
                });
            }
        }
    };

    const handleOptionSelect = (option) => {
        setSelectedOption(option);
        // Update header based on selected option
        if (option === 'deposit') {
            navigation.setOptions({
                headerTitle: 'Deposit Crypto'
            });
        } else if (option === 'convert') {
            navigation.setOptions({
                headerTitle: 'Convert to TradeX'
            });
        }
    };

    useEffect(() => {
        const unsubscribe = navigation.addListener('beforeRemove', (e) => {
            // Prevent default behavior of going back
            if (selectedOption) {
                e.preventDefault();
                setSelectedOption(null);
            }
        });

        return unsubscribe;
    }, [navigation, selectedOption]);

    useEffect(() => {
        navigation.setOptions({
            headerLeft: () => (
                <TouchableOpacity 
                    onPress={() => {
                        if (selectedOption) {
                            setSelectedOption(null);
                        } else {
                            navigation.goBack();
                        }
                    }}
                >
                    <Icon 
                        icon="solar:alt-arrow-left-linear" 
                        width={24} 
                        height={24}
                        color={globalConfigurableData.primaryTextColor1}
                    />
                </TouchableOpacity>
            ),
            headerTitle: selectedOption ? 
                (selectedOption === 'deposit' ? 'Deposit Crypto' : 'Convert to TradeX') : 
                'Add Funds'
        });
    }, [navigation, selectedOption]);

    const calculatePercentageAmounts = () => {
        if (!balance) return [];
        const percentages = [20, 40, 70, 95];
        return percentages.map(percentage => {
            const amount = parseFloat(balance) * (percentage / 100);
            // Round to nearest multiple of 10
            const roundedAmount = Math.round(amount / 10) * 10;
            return roundedAmount.toString();
        });
    };

    const getCouponList = async () => {
        const list = await Network.getCouponList();
        if (list?.data?.success) {
            setCouponList(list?.data?.coupons);
        }
    };

    useEffect(() => {
        getCouponList();
    }, []);

    const removePromo = () => {
        setValuePromo('promoCode', '');
        setPromoMessage('');
        setMessage({
            coupon: '',
            success: false,
            msg: '',
            applied_msg: '',
        });
    };

    const onSubmitPromoCode = data => {
        if (message?.status) {
            removePromo();
        } else {
            onPromoApply(data?.promoCode);
        }
    };

    const onPromoApply = async (promo, isManualPromo) => {
        const amount = watchamount;
        
        // Check if amount is within valid range
        if (!amount || amount < 1) {
            setMessage({
                coupon: promo,
                status: 'failed',
                msg: 'Please enter a valid amount',
                isManualError: true,
                divClass: {borderColor: Colors.red, borderWidth: 2},
            });
            return;
        }

        const inputObj = {
            couponcode: promo,
            amount: amount,
        };

        const res = await Network.verifyCouponCodeRecharge(inputObj, true);
        if (!res?.data?.success) {
            setPromoMessage('');
            setMessage({
                coupon: promo,
                status: 'failed',
                msg: res?.data?.msg,
                applied_msg: res?.data?.applied_msg,
                isShowPopUp: true,
                isManualError: res?.data?.msg,
                divClass: {borderColor: Colors.red, borderWidth: 2},
            });
        } else {
            setPromoMessage(promo);
            setPromoSuccessModal(true);
            setMessage({
                coupon: promo,
                status: 'success',
                msg: res?.data?.msg,
                applied_msg: res?.data?.applied_msg,
                isShowPopUp: true,
                divClass: {borderColor: Colors.green, borderWidth: 2},
            });
        }
    };

    const renderDepositScreen = () => (
        <View style={styles.contentContainer}>
            <View style={styles.qrWrapper}>
                <View style={styles.qrContainer}>
                    {publicAddress ? (
                        <QRCode value={publicAddress} size={140} backgroundColor="white" />
                    ) : (
                        <View style={styles.qrPlaceholder} />
                    )}
                </View>

                <Text style={styles.instructionText}>
                    Transfer your digital assets to the displayed address or scan the QR code above, and they will be deposited into your account.
                </Text>
            </View>

            <View style={styles.addressContainer}>
                <Input
                    name="walletAddress"
                    label="Wallet Address"
                    variant="default"
                    value={publicAddress.length > 16 ? `${publicAddress.substring(0, 8)}...${publicAddress.substring(publicAddress.length - 8)}` : publicAddress}
                    disabled
                    rules={{ required: true }}
                    rightIcon={() => (
                        <TouchableOpacity onPress={copyToClipboard}>
                            <Icon 
                                icon="solar:copy-linear" 
                                width={24} 
                                height={24}
                                color={globalConfigurableData.primaryBtnColor}
                            />
                        </TouchableOpacity>
                    )}
                    style={{ backgroundColor: Colors.lightgrey1 }}
                    inputStyle={{ backgroundColor: Colors.lightgrey1 }}
                    containerStyle={{ marginBottom: 8 }}
                />
            </View>

            <Text style={styles.balanceText}>Balance: {balance}</Text>
            
            <Input
                name="chain"
                label="Chain"
                value="Polygon"
                disabled
                variant="default"
                style={{ backgroundColor: Colors.lightgrey1 }}
                inputStyle={{ backgroundColor: Colors.lightgrey1 }}
                containerStyle={{ marginBottom: 18 }}
            />

            <Input
                name="token"
                label="Token"
                value={symbol || 'USDT'}
                disabled
                variant="default"
                style={{ backgroundColor: Colors.lightgrey1 }}
                inputStyle={{ backgroundColor: Colors.lightgrey1 }}
                containerStyle={{ marginBottom: 18 }}
            />

            <Input
                name="currentBalance"
                label="Current Balance"
                value={balance}
                disabled
                variant="default"
                style={{ backgroundColor: Colors.lightgrey1 }}
                inputStyle={{ backgroundColor: Colors.lightgrey1 }}
                containerStyle={{ marginBottom: 18 }}
            />
        </View>
    );

    const renderConvertScreen = () => (
        <View style={styles.contentContainer}>
            <View style={styles.section}>
                <View style={styles.transactionSection}>
                    <View>
                        <Input
                            control={control}
                            name="exchangeBalance"
                            label="Balance"
                            value={`${balance} ${symbol}`}
                            disabled
                            variant="default"
                            style={{ backgroundColor: Colors.lightgrey1 }}
                            inputStyle={{ backgroundColor: Colors.lightgrey1 }}
                        />
                        
                        <Input
                            control={control}
                            name="amountToConvert"
                            label="Amount to Convert"
                            value={currencyAmount}
                            onChangeText={handleCurrencyChange}
                            keyboardType="numeric"
                            placeholder="Enter amount"
                            variant="default"
                            rules={{
                                required: "Please enter an amount",
                                validate: {
                                    validNumber: (value) => !isNaN(parseFloat(value)) || "Please enter a valid number",
                                    minAmount: (value) => parseFloat(value) >= MIN_AMOUNT || `Amount must be greater than ${MIN_AMOUNT}`,
                                    maxBalance: (value) => {
                                        try {
                                            const amountInWei = ethers.parseUnits(value || '0', decimals).toString();
                                            return BigInt(amountInWei) <= BigInt(balanceInWei) || 'Amount exceeds available balance';
                                        } catch (error) {
                                            return "Invalid amount";
                                        }
                                    }
                                }
                            }}
                        />
                    </View>

                    <View style={styles.amountOptions}>
                        {calculatePercentageAmounts().map((amount, index) => (
                            <TouchableOpacity
                                onPress={() => handleAmountSelect(amount)}
                                activeOpacity={0.8}
                                key={index}
                                style={[
                                    styles.moneyTapContainer,
                                    index === 3 ? { marginRight: 0 } : null,
                                ]}
                            >
                                <Text style={{
                                    textAlign: 'center',
                                    color: globalConfigurableData.primaryTextColor1,
                                }}>{amount}</Text>
                            </TouchableOpacity>
                        ))}
                    </View>

                    {/* Add Coupon Code Section */}
                    <View style={[styles.promoCodeContainer]}>
                        <Text style={[globalFontStyle.appFontSmallText, { 
                            marginBottom: 8,
                            fontSize: 14,
                            color: Colors.grey,
                            opacity: 0.6,
                            fontFamily: globalFontStyle.appFontBody.fontFamily
                        }]}>
                            Promo Code
                        </Text>
                        <View style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                            backgroundColor: globalConfigurableData.cardBgColor,
                            borderRadius: 8,
                            borderWidth: 1,
                            overflow: 'hidden',
                            borderColor: message?.status === 'success' 
                                ? Colors.green 
                                : message?.status === 'failed' 
                                    ? Colors.red 
                                    : globalConfigurableData.borderColor,
                        }}>
                            <View style={{flex: 1}}>
                                <Input
                                    control={controlPromo}
                                    name="promoCode"
                                    placeholder="Enter promo code"
                                    disabled={!!promoMessage || !amountIsValid}
                                    variant="outline"
                                    containerStyle={{
                                        marginBottom: 0,
                                        backgroundColor: 'transparent',
                                        paddingHorizontal: 0,
                                    }}
                                    style={{
                                        borderWidth: 0,
                                    }}
                                    inputStyle={{
                                        borderWidth: 0,
                                        backgroundColor: 'transparent',
                                        height: 46,
                                    }}
                                    fullWidth
                                />
                            </View>
                            <View style={{
                                width: 1,
                                alignSelf: 'stretch',
                                backgroundColor: message?.status === 'success' 
                                    ? Colors.green 
                                    : message?.status === 'failed' 
                                        ? Colors.red 
                                        : globalConfigurableData.borderColor,
                            }} />
                            <TouchableOpacity
                                onPress={handleSubmitPromo(onSubmitPromoCode)}
                                disabled={!amountIsValid || !watchPromoCode}
                                style={{
                                    height: 46,
                                    paddingHorizontal: 20,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: 'transparent',
                                    opacity: amountIsValid && watchPromoCode ? 1 : 0.5,
                                }}>
                                <Text style={{
                                    ...globalFontStyle.appFontSmallTextBold,
                                    color: message?.status === 'success' 
                                        ? Colors.green 
                                        : message?.status === 'failed' 
                                            ? Colors.red 
                                            : !amountIsValid 
                                                ? Colors.grey 
                                                : globalConfigurableData.primaryTextColor1,
                                }}>
                                    {message?.status ? 'Remove' : 'Apply'}
                                </Text>
                            </TouchableOpacity>
                        </View>
                        {message?.msg && (
                            <FormTextLabel
                                labelStyles={[
                                    globalFontStyle.appFontSmallText,
                                    {
                                        color: message?.status === 'success' ? Colors.green : Colors.red,
                                        marginTop: 4
                                    },
                                ]}
                                label={message?.msg}
                            />
                        )}
                    </View>

                    <Button
                        variant="primary"
                        onPress={handleConvert}
                        loading={isLoading}
                        disabled={!currencyAmount || Object.keys(errors).length > 0}
                        style={styles.convertBtn}
                    >
                        Convert to Credits
                    </Button>
                </View>
            </View>
        </View>
    );

    return (
        <FormProvider {...methods}>
            <View style={styles.container}>
                {isLoading && (
                    <View style={styles.loaderContainer}>
                        <ActivityIndicator size="large" color={globalConfigurableData.loaderColor} />
                        <Text style={styles.loaderText}>{statusMessage || 'Processing...'}</Text>
                    </View>
                )}
                {!selectedOption ? (
                    <CryptoSelection onOptionSelect={setSelectedOption} />
                ) : (
                    <>
                        {selectedOption === 'deposit' && renderDepositScreen()}
                        {selectedOption === 'convert' && renderConvertScreen()}
                    </>
                )}
            </View>

            <CommonModal
                onModalCallBack={() => {
                    setPromoSuccessModal(false);
                }}
                persistent={true}
                customModalStyle={[globalStyle.modalStyleCenter]}
                showModal={promoSuccessModal}>
                <CouponSuccessScreen
                    dataObj={message}
                    onOkayClick={() => {
                        setPromoSuccessModal(false);
                    }}
                />
            </CommonModal>
        </FormProvider>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fff',
    },
    optionsContainer: {
    },
    optionItem: {
        paddingVertical: 20,
    },
    optionContent: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    iconContainer: {
        width: 56,
        height: 56,
        borderRadius: 28,
        borderWidth: 4,
        borderColor: globalConfigurableData.primaryBtnColor,
        justifyContent: 'center',
        alignItems: 'center',
    },
    textContainer: {
        marginLeft: 16,
        flex: 1,
    },
    arrowContainer: {
        width: 40,
        height: 40,
        justifyContent: 'center',
        alignItems: 'center',
    },
    optionTitle: {
        ...globalFontStyle.appFontHeading,
        color: globalConfigurableData.primaryTextColor1,
        marginBottom: 3,
    },
    optionDescription: {
        ...globalFontStyle.appFontSubText,
        lineHeight: 18,
        color: globalConfigurableData.secondaryTextColor1,
    },
    separator: {
        height: 1,
        backgroundColor: '#EEEEEE',
    },
    sectionTitle: {
        fontSize: 20,
        fontWeight: '600',
        marginBottom: 8,
        color: '#000',
    },
    sectionSubtitle: {
        fontSize: 14,
        color: '#666',
        marginBottom: 16,
    },
    balanceText: {
        fontSize: 14,
        color: '#666',
        marginBottom: 24,
    },
    qrWrapper: {
        alignItems: 'center',
        marginBottom: 24,
        paddingHorizontal: 16,
    },
    qrContainer: {
        padding: 12,
        backgroundColor: Colors.bgWhite,
        borderRadius: 12,
        borderWidth: 1,
        borderColor: Colors.borderColor,
        marginBottom: 24,
    },
    qrPlaceholder: {
        width: 140,
        height: 140,
        backgroundColor: Colors.grey4,
    },
    instructionText: {
        fontSize: 14,
        color: Colors.grey1,
        textAlign: 'center',
        lineHeight: 20,
        maxWidth: 300,
    },
    transactionTitle: {
        fontSize: 18,
        fontWeight: '600',
        marginBottom: 16,
        color: '#000',
        marginTop: 24,
    },
    amountOptions: {
        flexDirection: 'row',
        marginBottom: 18,
        width: '100%',

    },
    moneyTapContainer: {
        paddingHorizontal: 15,
        paddingVertical: 8,
        borderWidth: 0.75,
        borderColor: globalConfigurableData.borderColor,
        backgroundColor: globalConfigurableData.cardBgColor,
        borderRadius: 8,
        flex: 1,
        marginRight: 14,
    },
    errorText: {
        color: globalConfigurableData.errorTextColor1,
        fontSize: 12,
        marginTop: 5,
        minHeight: 14,
    },
    loaderContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        zIndex: 999
    },
    loaderText: {
        ...globalFontStyle.appFontMedium,
        color: globalConfigurableData.primaryTextColor1,
        marginTop: 12,
        textAlign: 'center',
    },
    contentContainer: {
        flex: 1,
    },
    section: {
        flex: 1,
    },
    transactionSection: {
        flex: 1,
    },
    convertBtn: {
        marginTop: 24,
    },
    promoCodeContainer: {
        marginBottom: 18,

    },
    promoCodeInput: {
        flexDirection: 'row',
        alignItems: 'center',
        borderWidth: 1,
        borderRadius: 8,
        overflow: 'hidden',
    },
});

export default WalletRecharge;